<div class="filter-block">
  
  <div class="row">
    <div class="delete-section">
      <i class="material-icons pullfloat-right" style="margin-right: unset" (click)="close()">close</i>
    </div>

    <div *ngIf="duplicateFilter" class="warning-section">WARNING: DUPLIUCATE FILTERS CANNOT BE USED</div>

    <div class="filter-selection">
        <select [(ngModel)]="thisFilter.type" class="form-control quote-select" (ngModelChange)="filterSelected()">
            <option *ngFor="let filter of CustomReportFilters">
                {{filter}}
            </option>
        </select>
      </div>

    <div class="value-selection">
      <div *ngIf="filterType=='text'">
        <input id="textInput" type="text" [(ngModel)]="thisFilter.value" class="form-control"/>
      </div>

      <div *ngIf="filterType=='dropdown'">
        <div *ngIf="this.thisFilter.type=='REPORTING PERIOD'">
            <!-- REPORTING PERIOD -->
            <select id="selectField" [(ngModel)]="thisFilter.value" class="form-control quote-select">
              <option *ngFor="let period of filterTimePeriods">
                {{period}}
              </option>
            </select>
        </div>
        <div *ngIf="this.thisFilter.type=='BRAND'">
        <!-- BRAND -->
        <select id="selectField" [(ngModel)]="thisFilter.value" class="form-control quote-select">
          <option *ngFor="let brand of Brands">
            {{brand}}
          </option>
        </select>
      </div>
      <div *ngIf="this.thisFilter.type=='STATE'">
        <!-- STATE -->
        <select id="selectField" [(ngModel)]="thisFilter.value" class="form-control">
          <option *ngFor="let state of States">{{state}}</option>
        </select>
      </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="additional-section">
        <div *ngIf="thisFilter.value=='SPECIFIC DATES'">
            <span  class="input-control text">
              <label>FROM:</label>
              <input id="textStartDate" [(ngModel)]="thisFilter.startDate" appCalendar (dateSelected)="thisFilter.startDate=$event">
            </span>
            <span class="input-control text">
              <label>TO:</label>
              <input id="textEndDate" [(ngModel)]="thisFilter.endDate" appCalendar (dateSelected)="thisFilter.endDate=$event">
            </span>
        </div>
    </div>
  </div>
</div>
